import React from 'react';
import { SourcesLayer } from './SourcesLayer';
import { GenerateLayer } from './GenerateLayer';
import { FusionLayer } from './FusionLayer';
import { DeployLayer } from './DeployLayer';

function Connector({ label }) {
  return (
    <div className="flex flex-col items-center py-1" aria-hidden="true">
      <div className="w-0.5 h-8 relative overflow-hidden bg-gradient-to-b from-white/5 via-white/35 to-white/5">
        <span className="absolute -top-2 left-0 w-1 h-2 rounded bg-white animate-[connflow_1.4s_linear_infinite]" />
      </div>
      <span className="font-mono text-[9px] tracking-[0.22em] uppercase text-white/30 mt-1.5">{label}</span>
    </div>
  );
}

export function Pipeline() {
  return (
    <div className="border border-white/10 rounded-2xl bg-white/[0.02] p-5 sm:p-7">
      <SourcesLayer />
      <Connector label="Schema + coordinates" />
      <GenerateLayer />
      <Connector label="Geometry" />
      <FusionLayer />
      <Connector label="Fused 3D replica" />
      <DeployLayer />
    </div>
  );
}
